import QueryParamsUtil from 'api/utils/query-params-util'
import axios from 'axios'

const API_PATH = 'api/v2/admins/tl_payment_methods'

const TlPaymentMethodsApiV2 = {
  /**
   * Get list of `District`
   * @param {string} bank - bank name
   * @return {object} axios response
   */

  get: ({
    //set default parameters
    ids = [],
    page = 1,
    perPage = 10,
    name = '',
    category = '',
    calculationType = '',
    isActive = '',
    gateway = ''
  }) => {
    const request  = {
      ids              : ids,
      page             : page,
      per_page         : perPage,
      category         : category,
      name             : name,
      calculation_type : calculationType,
      is_active        : isActive,
      gateway          : gateway
    }
    const params   = QueryParamsUtil.format(null, request)
    const path     = `${API_PATH}`
    const response = axios.get(path, { params })
    return response
  },
  show: (paymentMethodId) => {
    const path     = `${API_PATH}/${paymentMethodId}`
    const response = axios.get(path)
    return response
  },
  changeStatus: (paymentMethodId, isActive) => {
    const request  = {
      payment_method_id : paymentMethodId,
      is_active         : isActive
    }
    const path     = `${API_PATH}/change_status`
    const response = axios.patch(path, request)
    return response
  }
}

export default TlPaymentMethodsApiV2
